export const useT2 = useT2Create({
  Language: 'Kalba',
  // Catalog: 'Katalogas',
  Name: 'Vardas',
  User: 'Vartotojas',
  'Last name': 'Pavardė',
  'Terms and conditions': 'Terminai ir sąlygos',
  'Shipping & Delivery': 'Pristatymas',
  'Returns & Refunds': 'Grąžinimai',
  'About us': 'Apie mus',
  Filters: 'Filtrai',
  Sorting: 'Rikiavimas',
  Remove: 'Pašalinti',
  All: 'Visi',
  'No filters': 'Nėra filtrų',
  Primary: 'Pagrindiniai',
  'SKU search': 'SKU paieška',
  'All lists': 'Visi sąrašai',
  'Update list': 'Atnaujinti sąrašą',
  Back: 'Grįžti',
  Update: 'Atnaujinti',
  'Save lists': 'Išsaugoti',
  Search: 'Paieška',
  Empty: 'Tuščia',
  products: 'prekės',
  From: 'Nuo',
  More: 'Daugiau',
  Home: 'Pagrindinis',
  Information: 'Informacija',
  'Customer Care': 'Klientų aptarnavimas',
  Close: 'Uždaryti',
  Factories: 'Gamyklos',
  Location: 'Parduotuvė',
  Warranty: 'Garantija',
  Error: 'Klaida',
  'Upload photo': 'Įkelti nuotrauką',
  Password: 'Slaptažodis',
  Show: 'Rodyti',
  Hide: 'Slėpti',
  Edit: 'Redaguoti',
  'Available soon': 'Greitai prekyboje',
  'Add to cart': 'Į krepšelį',
  'Sold out': 'Išparduota',
  Buy: 'Pirkti',
  Open: 'Atidaryti',
  Zoom: 'Padidinti',
  Product: 'Prekė',
  'New product': 'Nauja prekė',
  'Read more': 'Skaityti daugiau',
  Payment: 'Apmokėjimas',
  Payments: 'Apmokėjimai',
  Products: 'Prekės',
  'All Products': 'Visos prekės',
  Added: 'Pridėta',
  Pay: 'Mokėti',
  Cart: 'Krepšelis',
  Clear: 'Išvalyti',
})
